<template>
    <div class="comment">
        <div class="user">
            <router-link v-bind:to="{ name: 'Profile' }">
                <img src="assets/images/avatar1.png" alt="User Avatar" class="avatar" />
            </router-link>
            <div class="user-details">
                <router-link class="name"
                    v-bind:to="{ name: 'Profile' }">Alexis Collado</router-link>
                <div class="time">Aug 16, 2018</div>
            </div>
        </div>

        <pre>Recent surveys show that over the last 20 years people are eating better and working out, resulting in people living longer, but people are still lacking in their understanding that their mental well being is just as important as their physical health.

        I also enjoy watching an hour or 2 of television every night, some light sitcoms are a great way to lighten your minds load, and laughing out loud for 30 seconds every day is a great way to release stress.</pre>

        <div class="icons">
            <div class="like" v-on:click="updateLikes">
                <i class="like-icon dark"
                    v-bind:class="{ liked: isLiked }"></i> {{ likes }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CommentItem',
        data: function() {
            return {
                isLiked: false,
                likes: Math.floor(Math.random() * (100 - 10)) + 10,
                likeTracker: 0
            }
        },
        methods: {
            updateLikes: function() {
                if (!this.isLiked) this.likes++
                else this.likes--

                this.isLiked = !this.isLiked
            }
        }
    }
</script>

<style scoped lang="scss">
    .comment {
        background-color: #FFF;
        border: 1px solid $light-gray;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 56px;
            padding: 20px 34px 28px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 15px;
            padding: 15px;
        }
    }


    .user {
        display: flex;
        align-items: center;
    }


    .user .avatar {
        flex-shrink: 0;

        @media all and (min-width: $breakpoint + 1) {
            width: 48px;
            height: 48px;
        }

        @media all and (max-width: $breakpoint) {
            width: 36px;
            height: 36px;
        }
    }


    .user-details {
        margin-left: 16px;

        @media all and (max-width: $breakpoint) {
            margin-left: 12px;
        }
    }


    .user-details .name {
        font-weight: $heavy;
        color: $accent;
    }


    .user-details .time {
        margin-top: 2px;
        font-size: 12px;
        color: $dark-gray;

        @media all and (max-width: $breakpoint) {
            font-size: 10px;
        }
    }


    .comment pre {
        margin: 24px 0 0;
        line-height: 30px;
        font-family: inherit;
        font-size: inherit;
        white-space: pre-line;

        @media all and (max-width: $breakpoint) {
            line-height: 20px;
            margin-top: 15px;
        }
    }


    .comment .icons {
        margin-top: 24px;

        @media all and (max-width: $breakpoint) {
            margin-top: 15px;
        }
    }


    .comment .like {
        display: flex;
        align-items: flex-end;
        width: max-content;
        font-weight: $book;
        color: $dark-gray;
        cursor: pointer;
    }


    .comment .like-icon {
        margin-right: 8px;
    }
</style>
